import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'lead-details',
	templateUrl: 'lead-details.component.html',
	styleUrls: ['lead-details.component.scss']
})

export class LeadDetailsComponent implements OnInit {

	@Input() leadId: number;

	ngOnInit() { }
}
